import { render, staticRenderFns } from "./BalanceChanges.vue?vue&type=template&id=1139c632&"
import script from "./BalanceChanges.vue?vue&type=script&lang=ts&"
export * from "./BalanceChanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports